// src/app/modules/Blacklist/components/AddToBlacklistModal.jsx
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../Dashbord/_redux/dashboard/Actions';
import { X, Ban } from 'lucide-react';
import './AddToBlacklistModal.scss';

export function AddToBlacklistModal({ show, onHide, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    visitor_name: '',
    visitor_phone: '',
    visitor_email: '',
    reason: 'suspicious_activity',
    severity: 'medium',
    description: '',
    share_with_network: true,
  });

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await dispatch(actions.addData('add_to_blacklist', {
        ...formData,
        organization_id: organizationId
      }));
      
      onHide();
      if (onSuccess) onSuccess();
      
      setFormData({
        visitor_name: '',
        visitor_phone: '',
        visitor_email: '',
        reason: 'suspicious_activity',
        severity: 'medium',
        description: '',
        share_with_network: true,
      });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="add-blacklist-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add to Blacklist</h5>
          <button className="close" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Visitor Name *</label>
                  <input
                    type="text"
                    name="visitor_name"
                    className="form-control"
                    value={formData.visitor_name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="visitor_phone"
                    className="form-control"
                    value={formData.visitor_phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Email (Optional)</label>
              <input
                type="email"
                name="visitor_email"
                className="form-control"
                value={formData.visitor_email}
                onChange={handleChange}
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Reason *</label>
                  <select
                    name="reason"
                    className="form-control"
                    value={formData.reason}
                    onChange={handleChange}
                    required
                  >
                    <option value="suspicious_activity">Suspicious Activity</option>
                    <option value="theft">Theft</option>
                    <option value="fraud">Fraud</option>
                    <option value="assault">Assault</option>
                    <option value="vandalism">Vandalism</option>
                    <option value="harassment">Harassment</option>
                    <option value="trespassing">Trespassing</option>
                    <option value="policy_violation">Policy Violation</option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Severity *</label>
                  <select
                    name="severity"
                    className="form-control"
                    value={formData.severity}
                    onChange={handleChange}
                    required
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="critical">Critical</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>Description *</label>
              <textarea
                name="description"
                className="form-control"
                rows={3}
                value={formData.description}
                onChange={handleChange}
                placeholder="Provide details about the incident..."
                required
              />
            </div>

            {/* <div className="form-group">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="share_with_network"
                  checked={formData.share_with_network}
                  onChange={handleChange}
                />
                <span>Share with network</span>
              </label>
              <small className="form-text text-muted">
                Other organizations will be alerted about this visitor
              </small>
            </div> */}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onHide} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2"></span>
                  Adding...
                </>
              ) : (
                <>
                  <Ban size={16} className="mr-2" />
                  Add to Blacklist
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}